import { Controller } from "@hotwired/stimulus"
import { application } from "./application"
import { Autocomplete } from "stimulus-autocomplete"

type ControllerModule = { default: typeof Controller }

const allFiles = import.meta.glob('./**/*', { eager: true })

const extractControllerName = (path: string): string | null => {
  const match = path.match(/\.\/(.+?)_controller\.(js|ts)$/)
  return match?.[1]?.replace(/[/_]/g, '-') ?? null
}

Object.entries(allFiles).forEach(([path, controller]) => {
  if (path === './application.ts' || path === './application.js') return
  if (path.startsWith('./utils/')) return

  if (!path.match(/_controller\.(js|ts)$/)) {
    throw new Error(
      `Fichier invalide: "${path}"\nLes fichiers doivent se terminer par '_controller.ts' ou '_controller.js'`
    )
  }

  const name = extractControllerName(path)
  if (!name) {
    throw new Error(`Impossible d'extraire le nom du contrôleur depuis "${path}"`)
  }

  application.register(name, (controller as ControllerModule).default)
})

application.register('autocomplete', Autocomplete)